"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62486],{

/***/ 62486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var hooks_useDownloadDesktopApp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85557);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22090);
/* harmony import */ var _desktop_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53400);





var DownloadButtons = function(param) {
    var source = param.source;
    var download = (0,hooks_useDownloadDesktopApp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().download;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .DownloadButtonsContainer */ .Kx, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "btn-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        onClick: function() {
                            download("macos");
                            _desktop_analytics__WEBPACK_IMPORTED_MODULE_3__/* .DesktopAppDownloadAnalytics.onDownloadDesktopApp */ .E.onDownloadDesktopApp({
                                os: "Mac",
                                source: source
                            });
                        },
                        src: "/images/download-macos".concat(source === "Stockbit Main Page" ? "-light" : "", ".svg"),
                        alt: "Download untuk MacOs",
                        className: "download-button"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "MacOS 12 or above"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "btn-container",
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        src: "/images/download-windows".concat(source === "Stockbit Main Page" ? "-light" : "", ".svg"),
                        alt: "Download untuk Windows",
                        className: "download-button",
                        onClick: function() {
                            download("windows");
                            _desktop_analytics__WEBPACK_IMPORTED_MODULE_3__/* .DesktopAppDownloadAnalytics.onDownloadDesktopApp */ .E.onDownloadDesktopApp({
                                os: "Windows",
                                source: source
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Windows 10 or above"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DownloadButtons);


/***/ }),

/***/ 53400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ DesktopAppDownloadAnalytics; }
/* harmony export */ });
/* unused harmony export EVENT */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var EVENT = {
    openDesktopAppLandingPage: "Open Desktop App Landing Page",
    onDownloadDesktopApp: "Download Desktop App"
};
var DesktopAppDownloadAnalytics = {
    onDesktopAppLandingPage: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENT.openDesktopAppLandingPage);
    },
    onDownloadDesktopApp: function(param) {
        var os = param.os, source = param.source;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENT.onDownloadDesktopApp, {
            Source: source,
            OS: os
        });
    }
};


/***/ }),

/***/ 22090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "GQ": function() { return /* binding */ ShareColumnContainer; },
/* harmony export */   "Iq": function() { return /* binding */ ShareYourSetupTitle; },
/* harmony export */   "Kx": function() { return /* binding */ DownloadButtonsContainer; },
/* harmony export */   "LR": function() { return /* binding */ HeroTitle; },
/* harmony export */   "P5": function() { return /* binding */ MobileImageList; },
/* harmony export */   "PW": function() { return /* binding */ AccordionItemWrapper; },
/* harmony export */   "Pu": function() { return /* binding */ ValuePoints; },
/* harmony export */   "RJ": function() { return /* binding */ ImageListRow; },
/* harmony export */   "SB": function() { return /* binding */ VideoMultiMonitor; },
/* harmony export */   "Sz": function() { return /* binding */ SeeGallery; },
/* harmony export */   "US": function() { return /* binding */ FAQContainer; },
/* harmony export */   "VM": function() { return /* binding */ Hero; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "WL": function() { return /* binding */ AccordionWrapper; },
/* harmony export */   "ZI": function() { return /* binding */ SystemRequirementWrapper; },
/* harmony export */   "_D": function() { return /* binding */ ValueCustomLayout; },
/* harmony export */   "ai": function() { return /* binding */ DownloadSectionLeft; },
/* harmony export */   "fN": function() { return /* binding */ ShareImgContainer; },
/* harmony export */   "jx": function() { return /* binding */ ValuePointItem; },
/* harmony export */   "n0": function() { return /* binding */ AccordionItemContainer; },
/* harmony export */   "nd": function() { return /* binding */ ValueMultiMonitor; },
/* harmony export */   "q$": function() { return /* binding */ ShareImgBody; },
/* harmony export */   "t2": function() { return /* binding */ ShareYourSetupSection; },
/* harmony export */   "t7": function() { return /* binding */ ImageWithShadow; },
/* harmony export */   "th": function() { return /* binding */ DownloadSection; },
/* harmony export */   "vE": function() { return /* binding */ ImageItem; },
/* harmony export */   "xR": function() { return /* binding */ ValuePointIconItem; }
/* harmony export */ });
/* unused harmony exports Value, AdvancedOrderbook, AdvancedOrderbookRight, CollapsibleHighlightedContainer, CollapsibleHighlightedItem, MobileAdvancedOrderbook, Card, CardContainer, CardIndicatorContainer, Dot, ShareSubTitle, ShareImgWrapper, TncText, TncLink */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71577);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71230);
/* harmony import */ var features_tradingsetup_components_ImageItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64412);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 30px 0;\n  margin: 100px auto;\n  height: 100%;\n\n  .fade {\n    box-shadow: 0px -90px 250px 72px rgba(0, 171, 107, 0.75);\n    margin: 0 270px;\n  }\n  .separator-wrapper {\n    display: flex;\n    justify-content: center;\n    width: 100vw;\n  }\n  .separator {\n    width: 80vw;\n    height: 2px;\n    background: radial-gradient(\n      circle farthest-corner at center center,\n      #00ab6b,\n      transparent\n    );\n  }\n  @media (min-width: 1080px) {\n    margin-top: 180px;\n  }\n  @media (max-width: 700px) {\n    margin-top: 66px;\n    padding: 50px 0;\n    .fade {\n      margin: 0 30px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 110vh;\n  opacity: 1;\n\n  @media (min-width: 1080px) {\n    min-height: unset;\n  }\n  @media (max-width: 767px) {\n    .image,\n    .video-hero {\n      top: -100% !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 877px;\n  ",
        "\n  .ellipse {\n    transform: rotate(180deg);\n    opacity: 0.8;\n  }\n  &.image-multi {\n    height: 750px;\n  }\n  .image {\n    position: relative;\n    top: -584px;\n    width: 80vw;\n    max-width: 1000px;\n    &.video-multi-monitor,\n    &.multi-monitor {\n      width: unset;\n      max-width: unset;\n    }\n  }\n\n  &.image-hero {\n    .ellipse {\n      position: relative;\n      top: 0px;\n    }\n    .image {\n      top: -660px;\n    }\n    .video-hero {\n      z-index: 1;\n      position: absolute;\n      left: 0;\n      transform: scale(0.98);\n      top: -656px;\n    }\n  }\n\n  &.image-value-mobile {\n    display: none;\n  }\n\n  @media (max-width: 820px) {\n    &.image-value-desktop {\n      display: none;\n    }\n    &.image-value-mobile {\n      display: flex;\n    }\n    .video-hero,\n    .hero-bezel {\n      top: -415px !important;\n    }\n  }\n\n  @media (max-width: 768px) {\n    height: 320px;\n    margin-top: 40px;\n    &.image-multi {\n      height: 150px;\n      .ellipse {\n        top: 5px;\n      }\n    }\n    &.image-hero {\n      .ellipse {\n        top: 15px;\n      }\n    }\n    .image {\n      top: -300px;\n\n      &.video-multi-monitor,\n      &.multi-monitor {\n        width: 80vw;\n        max-width: 1000px;\n      }\n    }\n    .ellipse {\n      width: 100%;\n      opacity: 1;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .image {\n      top: -190px !important;\n      width: 310px !important;\n    }\n\n    height: 320px;\n  }\n  @media only screen and (max-width: 767px) and (min-width: 536px) {\n    height: unset;\n    &.image-value {\n      margin-top: 0;\n      .image {\n        top: -200px !important;\n      }\n    }\n  }\n  @media only screen and (max-width: 728px) and (min-width: 498px) {\n    .video-hero,\n    .hero-bezel {\n      top: -222px !important;\n    }\n  }\n  @media only screen and (max-width: 820px) and (min-width: 820px) {\n    .video-hero,\n    .hero-bezel {\n      top: -555px !important;\n    }\n  }\n  @media only screen and (max-width: 767px) and (min-width: 536px) {\n    height: unset;\n    .multi-monitor {\n      top: -200px !important;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  display: block;\n  text-align: center;\n\n  font-size: 48px;\n  line-height: 58px;\n  .green {\n    color: #0BA16B;\n  }\n  p {\n    margin-bottom: 0;\n  }\n\n  &.duplicate {\n    position: absolute;\n    top: 0;\n    zIndex: 100,\n    opacity: 0\n  }\n\n  @media (max-width: 1080px) {\n    font-size: 46px !important;\n    line-height: 50px !important;\n  }\n  @media (max-width: 700px) {\n    font-size: 36px !important;\n    line-height: 40px !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n\n  ",
        " {\n    line-height: 68px;\n    font-size: 66px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  @media (max-width: 700px) {\n    width: 85vw;\n    ",
        " {\n      font-size: 40px;\n      line-height: 41px;\n      flex-direction: column;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  line-height: 26px;\n  text-align: center;\n  width: 505px;\n  @media (max-width: 700px) {\n    width: unset;\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 24px;\n  cursor: pointer;\n\n  .soon {\n    cursor: default;\n  }\n\n  img {\n    bakcground: #141414;\n    &.loading {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  @media (max-width: 700px) {\n    img {\n      width: 160px;\n    }\n  }\n  position: relative;\n  z-index: 1;\n\n  .btn-container {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    span {\n      color: #cbcbcb;\n      font-size: 14px;\n      line-height: 19px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 64px;\n  padding: 0 270px;\n  .image-example {\n    width: 80vw;\n    max-width: 1000px;\n  }\n  @media (max-width: 700px) {\n    padding: 0 30px;\n    margin-top: 0;\n    gap: 40px;\n    ",
        " {\n      font-size: 36px;\n      line-height: 40px;\n    }\n  }\n  @media (max-width: 768px) {\n    padding: 0 30px;\n  }\n  @media (max-width: 1024px) {\n    padding: 0 30px;\n  }\n  @media (min-width: 1024px) {\n    min-height: unset;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: -10px;\n  ",
        " {\n    max-width: 902.19px;\n  }\n  @media (max-width: 700px) {\n    margin-top: -120px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .images-wrapper {\n    position: relative;\n    .image {\n      width: 80vw;\n      max-width: 1000px;\n    }\n    video {\n      position: absolute;\n      left: 0;\n      transform: scale(0.98, 0.98);\n      top: 6px;\n    }\n  }\n  // for when advanced orderbook not ready\n  position: relative;\n  z-index: 1;\n  background: #141414;\n  padding-bottom: 228px;\n  // for when advanced orderbook not ready\n\n  @media (max-width: 700px) {\n    margin-top: -120px;\n    padding-bottom: 60px;\n    .image {\n      width: 100%;\n    }\n    video {\n      top: 0px;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  @media (max-width: 700px) {\n    &.value-points-icon {\n      flex-direction: row;\n    }\n    &.value-points {\n      gap: 24px;\n    }\n    flex-direction: column;\n  }\n\n  @media (max-width: 1024px) {\n    &.value-points {\n      gap: 24px;\n      flex-direction: column;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 168px;\n  align-items: center;\n  span {\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 700;\n    text-align: center;\n  }\n  img {\n    width: 50px;\n    height: 50px;\n  }\n  @media (max-width: 700px) {\n    width: unset;\n    gap: 10px;\n    span {\n      font-size: 14px;\n      line-height: 19px;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 21.37px;\n\n  width: 315px;\n\n  .text {\n    font-size: 32px;\n    line-height: 38.98px;\n    font-weight: 700;\n  }\n  .subtext {\n    font-size: 18px;\n    line-height: 30px;\n  }\n\n  @media (max-width: 700px) {\n    padding: 0 30px;\n\n    .text {\n      font-size: 24px;\n      line-height: 29.23px;\n    }\n\n    .subtext {\n      font-size: 16px;\n      line-height: 26px;\n    }\n\n    gap: 8px;\n  }\n  @media (max-width: 768px) {\n    padding: 0 30px;\n    width: unset;\n    &:nth-child(1) {\n      width: unset;\n    }\n\n    .text {\n      font-size: 24px;\n      line-height: 29.23px;\n    }\n\n    .subtext {\n      font-size: 16px;\n      line-height: 26px;\n    }\n\n    gap: 8px;\n  }\n  @media (max-width: 1024px) {\n    width: unset !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 40px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 358px;\n  position: relative;\n  z-index: 2;\n  background: #141414;\n  padding-bottom: 193px;\n  margin-top: 364px;\n  @media (max-width: 700px) {\n    flex-direction: column;\n    padding-bottom: 80px;\n    > div {\n      width: 80vw !important;\n      max-width: 1000px;\n    }\n  }\n  @media (max-width: 412px) {\n    display: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  width: 542px;\n  ",
        " {\n    text-align: start;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 250px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  .title {\n    cursor: pointer;\n    color: ",
        ";\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 26.8px;\n  }\n  .content {\n    font-size: 18px;\n    line-height: 30px;\n    max-height: 0px;\n    overflow: hidden;\n    max-height: ",
        ";\n    transition: max-height ",
        "\n      ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: 137px;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  .ellipse {\n    z-index: 1;\n    height: 877px;\n    max-width: 1300px;\n    width: 80%;\n  }\n  ",
        " {\n    margin-bottom: 64px;\n    margin-top: 122px;\n  }\n\n  @media (max-width: 700px) {\n    .ellipse {\n      height: 400px;\n      width: 98vw;\n    }\n    ",
        " {\n      padding: 0 50px;\n    }\n    padding-bottom: 68px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 800px;\n  position: relative;\n  z-index: 1;\n  @media (max-width: 960px) {\n    width: unset;\n    gap: 12px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 8px;\n  padding: 24px;\n  background-color: #171717;\n  align-items: center;\n  cursor: pointer;\n\n  .chevron {\n    transform: rotate(",
        "deg);\n    transition: all 0.5s ease-in-out;\n  }\n  border-radius: 8px;\n  @media (max-width: 768px) {\n    border: 1px solid #2e2e2e;\n    .chevron {\n      width: 24px;\n      height: 24px;\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  .collapsible {\n    background-color: #171717;\n    cursor: pointer;\n    width: 100%;\n    border: none;\n    text-align: left;\n    outline: none;\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 700;\n  }\n  .content {\n    max-height: 0;\n    overflow: hidden;\n    font-size: 18px;\n    line-height: 26px;\n    &.active {\n      max-height: 500px;\n      transition: max-height 0.8s ease-in-out;\n    }\n    &.inactive {\n      max-height: 0px;\n      transition: max-height 0.3s ease-out;\n    }\n  }\n  @media (max-width: 768px) {\n    .collapsible {\n      font-size: 18px;\n      line-height: 26px;\n    }\n    .content {\n      font-size: 16px;\n      line-height: 26px;\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 45px;\n  justify-content: center;\n  align-items: center;\n  .image {\n    width: 638px;\n    height: 358px;\n  }\n  .divider {\n    height: 289px;\n    width: 1px;\n    background: #2e2e2e;\n  }\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    align-items: center;\n    .image {\n      width: 100%;\n      padding: 0 30px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .image {\n      height: 178px;\n    }\n    .desktop-laptop {\n      height: 100%;\n    }\n  }\n  @media (max-width: 1080px) {\n    .divider {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  display: flex;\n  gap: 40px;\n  width: 501px;\n  ",
        " {\n    font-size: 48px;\n    line-height: 58px;\n    text-align: start;\n  }\n\n  @media (max-width: 700px) {\n    width: unset;\n    padding: 0 12px;\n    text-align: center;\n    gap: 20px;\n    align-items: center;\n    ",
        " {\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 20px;\n  position: relative;\n  z-index: 2;\n  background: #141414;\n  padding-bottom: 20px;\n  display: none;\n  @media (max-width: 412px) {\n    display: block;\n    margin: 0;\n    padding-left: 20px;\n    ",
        " {\n      margin-left: -20px;\n      margin-top: 60px;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #2e2e2e;\n  border-radius: 8px;\n  padding: 24px;\n  margin-top: 40px;\n  .title {\n    margin-top: 16px;\n    font-size: 18px;\n    line-height: 26px;\n  }\n  .subtitle {\n    font-size: 16px;\n    line-height: 26px;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  overflow: auto;\n  gap: 40px;\n  width: 90vw;\n  ::-webkit-scrollbar {\n    width: 0;\n  }\n  ::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: transparent;\n    border: none;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 24px;\n  width: 8px;\n  height: 8px;\n  background: ",
        ";\n  border-radius: 100%;\n  cursor: pointer;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  z-index: 2;\n  ",
        "\n  ",
        "\n  margin-top: ",
        ";\n  width: ",
        ";\n  top: -584px;\n  @media (max-width: 768px) {\n    top: -300px;\n    width: 80vw;\n  }\n\n  @media (max-width: 767px) {\n    top: -190px !important;\n    width: ",
        ";\n    ",
        "\n    margin-top: 0px;\n    ",
        "\n  }\n  @media only screen and (max-width: 680px) and (min-width: 536px) {\n    top: -200px !important;\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 501px;\n  gap: 20px;\n\n  .title {\n    font-size: 22px;\n    font-weight: 700;\n  }\n  .tabs {\n    display: flex;\n    gap: 32px;\n    .tab-head {\n      font-size: 18px;\n      font-weight: 700;\n      cursor: pointer;\n      &.active {\n        border-bottom: 1px solid #00ab6b;\n        color: #00ab6b;\n      }\n    }\n  }\n  .tab-content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  .tab-content-item {\n    display: flex;\n    gap: 6px;\n    font-size: 18px;\n    .key {\n      color: #cbcbcb;\n    }\n  }\n  @media (max-width: 768px) {\n    width: 80vw;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #ffffff;\n  font-weight: 700;\n  display: block;\n  text-align: center;\n\n  .green {\n    color: #0ba16b;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  background: #141414;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  padding: 64px 0;\n  overflow: hidden;\n\n  ",
        " {\n    font-size: ",
        ";\n    margin-bottom: 20px;\n  }\n\n  @media (min-width: 768px) {\n    ",
        " {\n      font-size: 48px;\n    }\n  }\n\n  @media (min-width: 992px) {\n    ",
        " {\n      font-size: 66px;\n      line-height: 68px;\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n\n  @media (min-width: 992px) {\n    font-size: 29px;\n    line-height: 40px;\n    margin-bottom: 40px;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  overflow-x: hidden;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  height: 416px;\n  gap: 28px;\n\n  margin-bottom: 20px;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: ",
        ";\n  height: 100%;\n  gap: 20px;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n\n  background: url(",
        ") no-repeat center;\n  background-size: cover;\n  border-radius: 18px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: 700;\n\n  padding: 14px 24px;\n  height: auto;\n\n  color: #00ab6b;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  & > img {\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 40px;\n  width: 100%;\n  overflow-x: auto;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  ::-webkit-scrollbar {\n    display: none; /* Safari and Chrome */\n  }\n\n  & > div {\n    margin-right: 12px;\n\n    &:first-child {\n      margin-left: 20px;\n    }\n\n    &:last-child {\n      margin-right: 20px;\n    }\n  }\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n  font-weight: bold;\n  color: #0ba16b;\n  margin: 0;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 30px;\n\n  @media (min-width: 992px) {\n    margin-bottom: 64px;\n  }\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}



var Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-f94a61ed-0"
})(_templateObject());
var Hero = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-f94a61ed-1"
})(_templateObject1());
var ImageWithShadow = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-2"
})(_templateObject2(), function(param) {
    var marginTop = param.marginTop;
    return marginTop && "margin-top: ".concat(marginTop, "px;");
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-3"
})(_templateObject3());
var HeroTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-4"
})(_templateObject4(), Title, Title);
var SubTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-f94a61ed-5"
})(_templateObject5());
var DownloadButtonsContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-6"
})(_templateObject6());
var Value = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-7"
})(_templateObject7(), Title);
var ValueMultiMonitor = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Value).withConfig({
    componentId: "sc-f94a61ed-8"
})(_templateObject8(), Title);
var ValueCustomLayout = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Value).withConfig({
    componentId: "sc-f94a61ed-9"
})(_templateObject9());
var ValuePoints = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-10"
})(_templateObject10(), function(param) {
    var _gap = param.gap, gap = _gap === void 0 ? 32 : _gap;
    return "".concat(gap, "px");
});
var ValuePointIconItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-11"
})(_templateObject11());
var ValuePointItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-12"
})(_templateObject12());
var AdvancedOrderbook = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-13"
})(_templateObject13());
var AdvancedOrderbookRight = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-14"
})(_templateObject14(), Title);
var CollapsibleHighlightedContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-15"
})(_templateObject15());
var CollapsibleHighlightedItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-16"
})(_templateObject16(), function(param) {
    var active = param.active;
    return active ? "#00AB6B" : "#FFFFFF60";
}, function(param) {
    var active = param.active;
    return active ? "200px" : 0;
}, function(param) {
    var active = param.active;
    return active ? "0.8s" : "0.4s";
}, function(param) {
    var active = param.active;
    return active ? "ease-in-out" : "ease-out";
});
var FAQContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-17"
})(_templateObject17(), Title, Title);
var AccordionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-18"
})(_templateObject18());
var AccordionItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-19"
})(_templateObject19(), function(param) {
    var active = param.active;
    return active ? "180" : "0";
});
var AccordionItemContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-20"
})(_templateObject20());
var DownloadSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-21"
})(_templateObject21());
var DownloadSectionLeft = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-22"
})(_templateObject22(), Title, Title);
var MobileAdvancedOrderbook = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-23"
})(_templateObject23(), Title);
var Card = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-24"
})(_templateObject24());
var CardContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-25"
})(_templateObject25());
var CardIndicatorContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-26"
})(_templateObject26());
var Dot = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-27"
})(_templateObject27(), function(param) {
    var active = param.active;
    return active ? "#00AB6B" : "#595959";
});
var VideoMultiMonitor = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].video.withConfig */ .ZP.video.withConfig({
    componentId: "sc-f94a61ed-28"
})(_templateObject28(), function(param) {
    var left = param.left;
    return left && "left: ".concat(left, "px;");
}, function(param) {
    var right = param.right;
    return right && "right: ".concat(right, "px;");
}, function(param) {
    var _marginTop = param.marginTop, marginTop = _marginTop === void 0 ? 0 : _marginTop;
    return "".concat(marginTop, "px");
}, function(param) {
    var width = param.width;
    return "".concat(width / 2 - 19, "px !important");
}, function(param) {
    var width = param.width;
    return "".concat(width / 2 - 8, "px !important");
}, function(param) {
    var left = param.left;
    return left && "left: 2px;";
}, function(param) {
    var right = param.right;
    return right && "right: 2px;";
});
var SystemRequirementWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-29"
})(_templateObject29());
// Share Your Setup Section
var ShareYourSetupTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f94a61ed-30"
})(_templateObject30());
var ShareYourSetupSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-f94a61ed-31"
})(_templateObject31(), ShareYourSetupTitle, function(param) {
    var isCampaignActive = param.isCampaignActive;
    return isCampaignActive ? "27px" : "34px";
}, ShareYourSetupTitle, ShareYourSetupTitle, function(param) {
    var isCampaignActive = param.isCampaignActive;
    return isCampaignActive ? "40px" : "64px";
});
var ShareSubTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-f94a61ed-32"
})(_templateObject32());
var ShareImgBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-33"
})(_templateObject33());
var ShareImgContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-34"
})(_templateObject34());
var ShareColumnContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-35"
})(_templateObject35(), function(param) {
    var _width = param.width, width = _width === void 0 ? "100%" : _width;
    return width;
});
var ShareImgWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-36"
})(_templateObject36(), function(param) {
    var _height = param.height, height = _height === void 0 ? "100%" : _height;
    return height;
}, function(param) {
    var _width = param.width, width = _width === void 0 ? "100%" : _width;
    return width;
}, function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage;
});
var SeeGallery = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    type: "link"
}).withConfig({
    componentId: "sc-f94a61ed-37"
})(_templateObject37());
var ImageItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(features_tradingsetup_components_ImageItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f94a61ed-38"
})(_templateObject38(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
});
var MobileImageList = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f94a61ed-39"
})(_templateObject39());
var ImageListRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f94a61ed-40"
})(_templateObject40());
var TncText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-f94a61ed-41"
})(_templateObject41());
var TncLink = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-f94a61ed-42"
})(_templateObject42());


/***/ }),

/***/ 64412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ImageItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/tradingsetup/components/Username/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 20px;\n  object-fit: cover;\n\n  @media screen and (min-width: 768px) {\n    width: 32px;\n    height: 32px;\n    border-radius: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 19px;\n  margin: 0;\n  color: #ffffff;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b294ee53-0"
})(_templateObject());
var UserAvatar = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-b294ee53-1"
})(_templateObject1());
var NameText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-b294ee53-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/features/tradingsetup/components/Username/index.tsx



var Username = function(param) {
    var _userImgSrc = param.userImgSrc, userImgSrc = _userImgSrc === void 0 ? "" : _userImgSrc, _username = param.username, username = _username === void 0 ? "" : _username;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        align: "middle",
        gutter: [
            8,
            0
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                children: userImgSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar, {
                    src: userImgSrc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                children: username && /*#__PURE__*/ (0,jsx_runtime.jsxs)(NameText, {
                    children: [
                        "@",
                        username
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_Username = (Username);

;// CONCATENATED MODULE: ./src/features/tradingsetup/components/ImageItem/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n\n  position: relative;\n  display: flex;\n  width: 100%;\n\n  cursor: pointer;\n\n  & > img {\n    width: 100%;\n    border-radius: 8px;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  opacity: 0;\n\n  background: linear-gradient(180deg, rgba(20, 20, 20, 0) 64.58%, #141414 100%);\n  transition: opacity 0.15s ease-out;\n\n  &:hover {\n    opacity: 1;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 8px;\n  z-index: 2;\n\n  @media screen and (min-width: 768px) {\n    padding: 8px;\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var ImgWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a50453a6-0"
})(styled_templateObject());
var Gradient = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a50453a6-1"
})(styled_templateObject1());
var UsernameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a50453a6-2"
})(styled_templateObject2());
var LinkWrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-a50453a6-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/features/tradingsetup/components/ImageItem/index.tsx






var ImageItem = function(_param) {
    var className = _param.className, _username = _param.username, username = _username === void 0 ? "" : _username, _src = _param.src, src = _src === void 0 ? "" : _src, _userImgSrc = _param.userImgSrc, userImgSrc = _userImgSrc === void 0 ? "" : _userImgSrc, _href = _param.href, href = _href === void 0 ? "" : _href, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "username",
        "src",
        "userImgSrc",
        "href"
    ]);
    if (!src) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgWrapper, {
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UsernameWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Username, {
                            username: username,
                            userImgSrc: userImgSrc
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                    src: src
                }, props))
            ]
        })
    });
};
/* harmony default export */ var components_ImageItem = (ImageItem);


/***/ }),

/***/ 85557:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var useDownloadDesktopApp = function() {
    var getUrl = function(os) {
        var path = os === "macos" ? "macos/Stockbit.dmg" : "windows/Stockbit.msi";
        var url = "".concat("https://sda-release-v2.stockbit.com", "/release/").concat(path);
        return url;
    };
    var download = function(os) {
        return window.open(getUrl(os), "_blank");
    };
    return {
        download: download,
        getUrl: getUrl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDownloadDesktopApp);


/***/ }),

/***/ 48028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ clevertapProfilingUser; },
/* harmony export */   "Lq": function() { return /* binding */ clevertapEvent; },
/* harmony export */   "QU": function() { return /* binding */ clevertapInitProfileQueue; },
/* harmony export */   "Vg": function() { return /* binding */ clearClevertapState; },
/* harmony export */   "nh": function() { return /* binding */ academyUserProfiling; },
/* harmony export */   "ze": function() { return /* binding */ academyEventAnalytic; }
/* harmony export */ });
/* unused harmony export clevertapProfilingUserEligible */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* eslint-disable no-underscore-dangle */ 


var clevertapProfileQueue = [];
function clevertapInitProfileQueue() {
    clevertapProfileQueue.forEach(function(instance) {
        return instance();
    });
    clevertapProfileQueue = [];
}
/**
 * this function will executes clevertap analytic based on isInitProfile
 * @param {boolean} isInitProfile
 * @param {string} username
 * @param {boolean} isVirtualTrading
 * @param {boolean} isTopUser
 * @param {boolean} isVerifiedUser
 * @param {boolean} isStockbitPro
 * @param {Date} registrationStartDate
 * @param {string} profilePictureUrl
 * @param {boolean} isSinarmasSecuritas
 * @param {string} email
 * @param {isStockbitSecuritas} isStockbitSecuritas
 * @return {void} no return after execute this function
 */ function clevertapProfilingUser(param) {
    var isInitProfile = param.isInitProfile, identity = param.identity, isVirtualTrading = param.isVirtualTrading, isTopUser = param.isTopUser, isVerifiedUser = param.isVerifiedUser, isStockbitPro = param.isStockbitPro, registrationStartDate = param.registrationStartDate, profilePictureUrl = param.profilePictureUrl, isSinarmasSecuritas = param.isSinarmasSecuritas, email = param.email, isStockbitSecuritas = param.isStockbitSecuritas, _isEmitenUser = param.isEmitenUser, isEmitenUser = _isEmitenUser === void 0 ? false : _isEmitenUser;
    // Track if username is empty
    if (!identity) {
        (0,_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(new Error("[CT initialization Error]: username is empty"), {
            place: "src/utils/clevertap.ts",
            event: "clevertapProfilingUser",
            eventParam: {
                profile: {
                    identity: identity,
                    email: email
                }
            }
        });
    }
    var clevertapProfilingData = {
        Name: identity,
        Identity: identity,
        "Is Virtual Trading": isVirtualTrading !== undefined ? isVirtualTrading : undefined,
        "Is Top User": isTopUser !== undefined ? isTopUser : undefined,
        "Is Verified User": isVerifiedUser !== undefined ? isVerifiedUser : undefined,
        "Is Stockbit Pro": isStockbitPro !== undefined ? isStockbitPro : undefined,
        "Registration Start Date": registrationStartDate !== undefined ? registrationStartDate : undefined,
        Photo: profilePictureUrl !== undefined ? "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU, "/").concat(profilePictureUrl) : undefined,
        "Is Sinarmas Sekuritas": isSinarmasSecuritas !== undefined ? isSinarmasSecuritas : undefined,
        Email: email !== undefined ? email : undefined,
        "Is Stockbit Sekuritas": isStockbitSecuritas !== undefined ? isStockbitSecuritas : undefined,
        "Is Emiten User": isEmitenUser !== undefined ? isEmitenUser : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingData).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingData[key] !== undefined) {
            _acc[key] = clevertapProfilingData[key];
        }
        return _acc;
    }, {});
    var handleInitProfile = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.onUserLogin.push({
            Site: payload
        });
    };
    var handleProfilePush = function() {
        var ref;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
            Site: payload
        });
    };
    var initProfileFunction = isInitProfile ? handleInitProfile : handleProfilePush;
    if (!window.clevertap) {
        clevertapProfileQueue.push(initProfileFunction);
        return;
    }
    initProfileFunction();
}
function clevertapEvent(eventName) {
    var eventObject = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Object.keys(eventObject).length > 0) {
        var // execute this impression if impression has additional attributes
        ref, ref1;
        (ref = window.clevertap) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.push(eventName, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventObject));
    } else {
        var ref2, ref3;
        (ref2 = window.clevertap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.push(eventName);
    }
}
function clevertapProfilingUserEligible(param) {
    var followers = param.followers, following = param.following, posts = param.posts, isMuted = param.isMuted, isVerifiedEligible = param.isVerifiedEligible;
    var clevertapProfilingDataEligible = {
        Followers: followers !== undefined ? followers : undefined,
        Following: following !== undefined ? following : undefined,
        Posts: posts !== undefined ? posts : undefined,
        "is Muted": isMuted !== undefined ? isMuted : undefined,
        "Is Verified Badge Eligible": isVerifiedEligible !== undefined ? isVerifiedEligible : undefined
    };
    // filter to remove undefined value of object
    var payload = Object.keys(clevertapProfilingDataEligible).reduce(function(acc, key) {
        var _acc = acc;
        if (clevertapProfilingDataEligible[key] !== undefined) {
            _acc[key] = clevertapProfilingDataEligible[key];
        }
        return _acc;
    }, {});
    window.clevertap.profile.push({
        Site: payload
    });
}
function academyEventAnalytic(eventName, parameter) {
    if (!eventName) {
        return;
    }
    clevertapEvent(eventName, parameter);
}
function academyUserProfiling() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    var ref;
    if (!data && !data.parameter) {
        return;
    }
    // filter to remove undefined value of object
    // eslint-disable-next-line array-callback-return
    var payload = Object.keys(data.parameter).reduce(function(acc, key) {
        var currentAcc = acc;
        if (data[key] !== undefined) {
            currentAcc[key] = data[key];
            return currentAcc;
        }
        return null;
    }, {});
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.profile.push({
        Site: payload
    });
}
function clearClevertapState() {
    var ref, ref1;
    (ref = window.clevertap) === null || ref === void 0 ? void 0 : ref.logout();
    (ref1 = window.clevertap) === null || ref1 === void 0 ? void 0 : ref1.clear();
}


/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14229);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ })

}]);